import Select from 'react-select';
import { useSelector } from 'react-redux';

import { RootState } from 'slices';
import { CustomReactSelectStyles } from 'pages/Promotions/styles/customStyles';

export interface SettingsSelectOption<T extends string | number = string | number> {
  value: T;
  label: string;
}

interface SettingsSelectProps<T extends string | number = string | number> {
  inputId: string;
  value: T | null | undefined;
  options: SettingsSelectOption<T>[];
  onChange: (value: T) => void;
  onBlur?: () => void;
  isDisabled?: boolean;
  placeholder?: string;
}

const SettingsSelect = <T extends string | number = string | number>({
  inputId,
  value,
  options,
  onChange,
  onBlur,
  isDisabled = false,
  placeholder,
}: SettingsSelectProps<T>) => {
  const isDarkMode = useSelector(
    (state: RootState) => state.Layout.layoutModeType === 'dark'
  );

  const selectedOption =
    options.find((option) => String(option.value) === String(value)) ?? null;

  return (
    <Select
      inputId={inputId}
      options={options}
      value={selectedOption}
      onChange={(option: SettingsSelectOption<T> | null) => {
        if (option) onChange(option.value as T);
      }}
      onBlur={onBlur}
      isDisabled={isDisabled}
      isSearchable={false}
      placeholder={placeholder}
      styles={CustomReactSelectStyles(isDarkMode)}
      classNamePrefix={isDarkMode ? 'rs-dark' : 'rs'}
    />
  );
};

export default SettingsSelect;
